// src/components/AdProviderDataGrid.js

import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';

const AdProviderDataGrid = ({ providers, loading, onEdit, onViewDetails }) => {
  const columns = [
    { field: 'slNo', headerName: 'Sl No', width: 80 },
    { field: 'name', headerName: 'Provider Name', width: 200 },
    { field: 'email', headerName: 'Email', width: 200 },
    { field: 'phoneNumber', headerName: 'Phone Number', width: 150 },
    { field: 'whatsapp', headerName: 'WhatsApp Number', width: 150 },
    { field: 'address', headerName: 'Address', width: 200 },
    { field: 'pincode', headerName: 'Pincode', width: 100 },
    { field: 'districtName', headerName: 'District', width: 150 },
    { field: 'talukName', headerName: 'CONSTITUENCY', width: 150 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const providerId = params.row._id;

        return (
          <React.Fragment>
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{ marginRight: 8 }}
              onClick={() => onViewDetails(providerId)}
            >
              View Ads
            </Button>
            {onEdit && (
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => onEdit(params.row)}
              >
                Edit
              </Button>
            )}
          </React.Fragment>
        );
      },
    },
  ];

  // Mapping providers to rows for DataGrid
  const rows = providers.map((provider, index) => ({
    id: provider._id, // Unique identifier
    slNo: index + 1,
    _id: provider._id,
    name: provider.name,
    email: provider.email || 'N/A',
    phoneNumber: provider.phoneNumber,
    whatsapp: provider.whatsapp || 'N/A',
    address: provider.address,
    pincode: provider.pincode,
    districtName: (provider.districtId && provider.districtId.name) ? provider.districtId.name : 'N/A',
    talukName: (provider.talukId && provider.talukId.name) ? provider.talukId.name : 'N/A',
  }));

  return (
    <div style={{ height: 600, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        pageSize={25}
        rowsPerPageOptions={[25]}
        disableSelectionOnClick
        autoHeight
      />
    </div>
  );
};

export default AdProviderDataGrid;
